export class Menu {
    constructor() {
        this.id = 0,
            this.caption = ""
        this.name = "",
            this.fecha_creacion = ""
        this.usuario_creacion = ""
        this.fecha_actualizacion = ""
        this.usuario_actualizacion = ""
        this.activo = true
        this.submenus = []

    }
}